export const searchTypes = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
};

export const defaultOptionPropConfig = { name: 'id', text: 'name' };
